/**
 * @author twu
 * @description 配置表字段新增/编辑页面
 * @Date 2021/6/22
 */
import React from "react";
import {connect} from "dva";

import {component_tool, framework_tool, utils_tool} from '@/tool';
import TableFieldEnumList from "./tableFieldEnum/tableFieldEnumList";

let {WizContainer, modelUtils, WizAvatarUpload, ossFileUtils} = framework_tool;
let {WizCard, WizForm, WizSpin, WizInput,Wizmessage,WizButton} = component_tool;
let {Session} = utils_tool

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/dataReport/tableConfig/tableField/upd') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('tableConfigUpdInfo', record)
      } else {
        record = Session.get('tableConfigUpdInfo') || 0
      }
    }else if (history.location.pathname === '/dataReport/tableConfig/tableField/add') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('tableConfigAddInfo', record)
      } else {
        record = Session.get('tableConfigAddInfo') || 0
      }
    }
  }
  return record
}
class TableFieldDetail extends WizContainer {
  componentName = 'tableFieldDetail';

  constructor(props) {
    super(props);
    const {history} = props;

    let initialValue = getParamRecord(props.history);
    let initialValue_ = getParamRecord(props.history);
    let fieldType = 0;
    if (initialValue && initialValue.fieldType!=null){
      fieldType = initialValue.fieldType;
    }
    let enumList = [];
    if (initialValue && initialValue.fieldExtInfo && initialValue.fieldExtInfo.enumList){
      enumList = initialValue.fieldExtInfo.enumList;
    }
    let neoValue = Object.assign([]);
    let neoValue_ = Object.assign([]);
    if (enumList && enumList instanceof Array && enumList.length>0){
      enumList.forEach(data => {
        const {code} = data;
        data.key = new Date().getTime() + '_'+ code + '_tableFieldEnum';
        neoValue.push(data);
        neoValue_.push({...data});
      });
    }
    this.state = {
      fieldType:fieldType
    }
    this.initTargetEnumList=neoValue_;
    this.enumList = neoValue;
    this.initialValue = initialValue;
    this.clearWizCallBack = [];
  }


  propsAndStateOnChange = {
    saveTableField: this._saveOver.bind(this)
  }


  _saveOver(nextProps, nextState) {
    if (nextProps.saveTableField.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/dataReport/tableConfig/tableField', { id: this.initialValue.tableConfigId });
    } else {
      wizNotice.error('提交失败：' + nextProps.saveTableField.msg);
    }
    return true;
  }


  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    let fieldExtInfo = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'enumList' && value != null && value != undefined) {
        fieldExtInfo.enumList=value;
      }
      if (key === 'plugins' && value != null && value != undefined) {
        fieldExtInfo.plugins=value;
      }
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    fitterValues.fieldExtInfo = fieldExtInfo;
    return fitterValues;
  }

  /**
   * 保存/更新
   * @param values
   * @private
   */
  _save(values) {
    const {history} = this.props;
    let apiPath = "tableField/add";
    if (this.initialValue.id) {
      apiPath = "tableField/update"
    }
    let fitterValues = this.fitterFieldsValue(values);
    this.doAction({
      path: apiPath,
      payload: {
        key: 'saveTableField',
        apiParams: {
          ...fitterValues
        }
      }
    });
  }

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  /**
   * 重置表单
   */
  handleReset = () => {
    let neoValue = Object.assign([]);
    if (this.initTargetEnumList.length>0){
      this.initTargetEnumList.forEach(data => {
        neoValue.push({...data});
      });
    }
    let fieldType = 0;
    this.enumList = neoValue;
    if (this.initialValue && this.initialValue.fieldType!=null){
      fieldType = this.initialValue.fieldType;
    }
    this.setState({
      fieldType : fieldType,
    })
    this.formData.resetFields();
    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
  };

  /**
   * 表单提交按钮
   */
  _submit() {
    return (
      <div style={{textAlign: 'center'}}>
        <WizButton style={{marginLeft: 20}} title="提交" type="primary" htmlType="submit">提交</WizButton>
        <WizButton style={{marginLeft: 20}} onClick={this.handleReset}>重置</WizButton>
      </div>

    )

  }

  _render() {
    const {tableFieldLoading} = this.props;
    let {fieldType} = this.state;
    let columns = [
      {
        formItem: {
          type: "hidden",
          initialValue: this.initialValue && this.initialValue.id
        },
        name: "id"
      },
      {
        formItem: {
          type: "hidden",
          initialValue: this.initialValue && this.initialValue.tableConfigId
        },
        name: "tableConfigId"
      },
      {
        title: "字段英文名",
        name: "fieldCode",
        dataIndex: "fieldCode",
        formItem: {
          maxLength: 64,
          placeholder: '字段英文名不能超过64个字符',
          rules: [
            {
              required: true,
              message: '请输入字段英文名'
            }
          ],
          initialValue: this.initialValue && this.initialValue.fieldCode
        }
      },
      {
        title: "字段中文名",
        name: "fieldName",
        dataIndex: "fieldName",
        formItem: {
          maxLength: 64,
          placeholder: '字段中文名不能超过64个字符',
          rules: [
            {
              required: true,
              message: '请输入字段中文名'
            }
          ],
          initialValue: this.initialValue && this.initialValue.fieldName
        }
      },
      {
        title: "搜索名称",
        name: "searchName",
        dataIndex: "searchName",
        formItem: {
          maxLength: 64,
          placeholder: '搜索名称不能超过64个字符',
          initialValue: this.initialValue && this.initialValue.searchName
        }
      },
      {
        title: "设为关联字段",
        name: "fieldRelation",
        dataIndex: "fieldRelation",
        dict: [
          { code: 0, codeName: "否" },
          { code: 1, codeName: "是" }
        ],
        formItem: {
          type: 'select',
          rules: [{
            required: true,
            message: '请选择是否为关联字段',
          }],
          initialValue: this.initialValue && this.initialValue.fieldRelation!=null ? this.initialValue.fieldRelation : 0
        }
      },
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        dict: [
          { code: 0, codeName: "无效" },
          { code: 1, codeName: "有效" }
        ],
        formItem: {
          type: 'select',
          rules: [{
            required: true,
            message: '请选择状态',
          }],
          initialValue: this.initialValue && this.initialValue.state!=null ? this.initialValue.state : 1
        }
      },
      {
        title: "字段搜索类型",
        name: "fieldType",
        dataIndex: "fieldType",
        dict: [
          { code: 0, codeName: "文本" },
          // { code: 1, codeName: "数字" },
          // { code: 2, codeName: "时间" },
          { code: 3, codeName: "枚举" },
          { code: 4, codeName: "自定义插件" }
        ],
        formItem: {
          type: 'select',
          rules: [{
            required: true,
            message: '请选择字段搜索类型',
          }],
          onChange: (form,value) => {
            this.setState({
              fieldType : value,
            })
          },
          initialValue: this.initialValue && this.initialValue.fieldType!=null ? this.initialValue.fieldType : 0
        }
      },
    ]
    let dynamicColumns = [];
    if (fieldType!=null){
      //枚举
      if (fieldType===3){
        dynamicColumns.push(
          {
            title: "枚举项",
            name: "enumList",
            formItem: {
              type: 'diy',
              diy: TableFieldEnumList,
              initialValue: this.enumList ? this.enumList : [],
              rules: [{
                required: true,
                message: '请添加枚举项',
              }]
            }
          }
        )
      }else if (fieldType===4){
        //自定义插件
        dynamicColumns.push(
          {
            title: "自定义插件",
            name: "plugins",
            dataIndex: "plugins",
            formItem: {
              maxLength: 64,
              placeholder: '自定义插件不能超过64个字符',
              rules: [
                {
                  required: true,
                  message: '请输入自定义插件'
                }
              ],
              initialValue: this.initialValue && this.initialValue.fieldExtInfo && this.initialValue.fieldExtInfo.plugins,
            }
          }
        )
      }
    }
    let allColumns = [...columns,...dynamicColumns];
    let onSubmit = this._save.bind(this);

    let formProps = {
      ref: 'form',
      columns:allColumns,
      onSubmit,
      record: null,
      preview: null,
      footer: null,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }
    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={tableFieldLoading}>
          <WizForm key={'tableFieldDetailForm'} className={'form-inline'} {...formProps} ref={r => {
            this.formData = r
          }}>
            {this._submit()}
          </WizForm>
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {tableField} = state;
  const saveTableField = modelUtils.getModelEntity(tableField, "saveTableField");
  const load = modelUtils.getLoadingState(state, ['tableField']);
  return {
    saveTableField,
    ...load
  }
};

export default connect(mapStateToProps)(TableFieldDetail);
